<kkm-menu [buttons]="buttons()">
    <div id="wrapper">
        <router-outlet></router-outlet>
    </div>
</kkm-menu>
